import { render, staticRenderFns } from "./RaceItem.vue?vue&type=template&id=4f70485a&scoped=true&"
import script from "./RaceItem.vue?vue&type=script&lang=js&"
export * from "./RaceItem.vue?vue&type=script&lang=js&"
import style0 from "./RaceItem.vue?vue&type=style&index=0&id=4f70485a&prod&lang=scss&scoped=true&"
import style1 from "./RaceItem.vue?vue&type=style&index=1&id=4f70485a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f70485a",
  null
  
)

export default component.exports